import SearchForDataset from "./SearchForDataset.svelte";
import StationDetail from "./StationDetail.svelte";
import DatasetSearchable from "./DatasetSearchable.svelte";
import Cart from "./Cart.svelte";
import TaxonomySearch from "./TaxonomySearch.svelte";
import OrderStatus from "./OrderStatus.svelte";
import CartButton from "./components/cart/CartButton.svelte";
import FindAStation from "./FindAStation.svelte";
import DatasetStatic from "./DatasetStatic.svelte";
import ExtremesPrecipitation from "./ExtremesPrecipitation.svelte";
import PublicationsSearchable from "./PublicationsSearchable.svelte";
import RadarDatasetSearchable from "./RadarDatasetSearchable.svelte";
import DatasetMapless from "./DatasetMapless.svelte";
import NexradLevel1Searchable from "./NexradLevel1Searchable.svelte";
import SRRSSearchable from "./SRRSSearchable.svelte";
import GlobalMarineSearchable from "./GlobalMarineSearchable.svelte";
window.addEventListener('error', (event) => {
    console.error('Encountered an unhandled error:', event.error);
});
window.addEventListener('unhandledrejection', (event) => {
    console.error('Unhandled promise rejection:', event.reason);
});
let app;
if (document.querySelector("#dataset-search")) {
    app = new SearchForDataset({
        target: document.querySelector("#dataset-search"),
        props: {}
    });
}
if (document.querySelector("#station-detail")) {
    app = new StationDetail({
        target: document.querySelector("#station-detail"),
        props: {}
    });
}
if (document.querySelector("#dataset-searchable")) {
    app = new DatasetSearchable({
        target: document.querySelector("#dataset-searchable"),
        props: {}
    });
}
if (document.querySelector("#dataset-static")) {
    app = new DatasetStatic({
        target: document.querySelector("#dataset-static"),
        props: {}
    });
}
if (document.querySelector("#dataset-mapless")) {
    app = new DatasetMapless({
        target: document.querySelector("#dataset-mapless"),
        props: {}
    });
}
if (document.querySelector("#radar-dataset-searchable")) {
    app = new RadarDatasetSearchable({
        target: document.querySelector("#radar-dataset-searchable"),
        props: {}
    });
}
if (document.querySelector("#extremes-precipitation")) {
    app = new ExtremesPrecipitation({
        target: document.querySelector("#extremes-precipitation"),
        props: {}
    });
}
if (document.querySelector("#publications-generic")) {
    app = new PublicationsSearchable({
        target: document.querySelector("#publications-generic"),
        props: {}
    });
}
if (document.querySelector("#cartbutton")) {
    const cartButton = document.querySelector("#cartbutton");
    app = new CartButton({
        target: cartButton,
        props: { cartURL: cartButton.getAttribute("cartURL") }
    });
}
if (document.querySelector("#cart-page")) {
    app = new Cart({
        target: document.querySelector("#cart-page"),
        props: {}
    });
}
if (document.querySelector("#find-a-station")) {
    app = new FindAStation({
        target: document.querySelector("#find-a-station"),
        props: {}
    });
}
if (document.querySelector("#taxonomy-search")) {
    app = new TaxonomySearch({
        target: document.querySelector("#taxonomy-search"),
        props: {}
    });
}
if (document.querySelector("#order-status")) {
    app = new OrderStatus({
        target: document.querySelector("#order-status"),
        props: {}
    });
}
if (document.querySelector("#nexrad-level-1-searchable")) {
    app = new NexradLevel1Searchable({
        target: document.querySelector("#nexrad-level-1-searchable"),
        props: {}
    });
}
if (document.querySelector("#service-records-retention-system")) {
    app = new SRRSSearchable({
        target: document.querySelector("#service-records-retention-system"),
    });
}
if (document.querySelector("#global-marine-searchable")) {
    app = new GlobalMarineSearchable({
        target: document.querySelector("#global-marine-searchable"),
        props: {}
    });
}
export default app;
